import { render, staticRenderFns } from "./Merge.vue?vue&type=template&id=62bb4746&scoped=true&"
import script from "./Merge.vue?vue&type=script&lang=js&"
export * from "./Merge.vue?vue&type=script&lang=js&"
import style0 from "./Merge.vue?vue&type=style&index=0&id=62bb4746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bb4746",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bb4746')) {
      api.createRecord('62bb4746', component.options)
    } else {
      api.reload('62bb4746', component.options)
    }
    module.hot.accept("./Merge.vue?vue&type=template&id=62bb4746&scoped=true&", function () {
      api.rerender('62bb4746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Merge.vue"
export default component.exports